import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as actions from '../../redux/actions/actions-users';
import Button from '../../components/Button';
import SearchBar from '../../components/SearchBar';
import BreadCrumb from '../../components/Breadcrumb';
import Loader from '../../components/Loader';

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVal: ''
    };
    props.getUserslist();
  }


  deleteUsers = (id) => {
    confirmAlert({
      title: 'Delete Users',
      message: 'Are you sure to delete the User?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.props.deleteUsers(id)
              .then(() => {
                toast.success('Deleted Successfully');
              }).catch((error) => {
                toast.error(error.message);
              });
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleTableFilter = (search) => {
    this.setState({ searchVal: search });
  }

  setTableOption = () => (this.props.UsersList && this.props.tableLoading ? <Loader /> : 'No Data Found');

  render() {
    const searchVal = this.state.searchVal.toLowerCase();
    const usersData = this.props.UsersList.filter((item) => (item.StudentName && item.StudentName.toLowerCase().includes(searchVal)) || (item.EmailId && item.EmailId.toLowerCase().includes(searchVal)));

    const columns = [{
      dataField: 'StudentName',
      text: 'Users Name'
    }, {
      dataField: 'EmailId',
      text: 'Email Id'
    }, {
      dataField: 'LoginId',
      text: 'Login Id'
    }, {
      dataField: 'IsActive',
      text: 'Status',
      formatter: (cell, row) => (cell ? <label className="badge badge-success">Active</label> : <label className="badge badge-danger">In-Active</label>),
      headerStyle: {
        width: '80px'
      }
    }, {
      dataField: 'CreatedDateTime',
      text: 'Created at',
      formatter: (cell, row) => (
        cell ? new Date(cell).toLocaleDateString() : '--'
      ),
      headerStyle: {
        width: '120px'
      },
      sort: true
    }, {
      dataField: 'Id',
      text: 'Actions',
      headerStyle: {
        width: '140px'
      },
      formatter: (cell, row) => (
        <>
          <span
            role="presentation"
            className="fa fa-pencil-alt tableEdit"
            onClick={() => this.props.history.push(`/users-editor/${cell}`)}
          />
          <span
            role="presentation"
            className="fa fa-trash tableDelete"
            onClick={() => this.deleteUsers(cell)}
          />
        </>
      )
    }];

    const defaultSorted = [{
      dataField: 'CreatedDateTime',
      order: 'desc'
    }];

    return (
      <div>
        <div className="container">
          <BreadCrumb currentPage="Users" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    {/* <span className="fa fa-file-alt cardTitle"> Users</span> */}
                    <SearchBar
                      placeholder="Search by Student Name, Email Id"
                      handleChange={(e) => this.handleTableFilter(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <Button
                      className="btn btn-sm btn-secondary ml-3"
                      onClick={() => this.props.history.push('/users-editor/0')}
                    >
                      <span className="fas fa-plus" />
                      {' '}
                      Add New
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">

                <BootstrapTable
                  keyField="Id"
                  data={usersData}
                  columns={columns}
                  pagination={paginationFactory()}
                  defaultSorted={defaultSorted}
                  noDataIndication={() => this.setTableOption()}
                  hover
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Users.defaultProps = {
  tableLoading: false,
  UsersList: null,
  getUserslist: null,
  deleteUsers: null
};

Users.propTypes = {
  tableLoading: PropTypes.bool,
  UsersList: PropTypes.array,
  getUserslist: PropTypes.func,
  deleteUsers: PropTypes.func
};

const mapStateToProps = ({ users }) => ({
  tableLoading: users.tableLoading,
  UsersList: users.usersList
});

const mapDispatchToProps = (dispatch) => ({

  getUserslist: () => dispatch(actions.fetchUsers()),
  deleteUsers: (id) => dispatch(actions.deleteUsers(id))

});

export default connect(mapStateToProps, mapDispatchToProps)(Users);
